"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var babylonjs_1 = require("babylonjs");
var logger_1 = require("./logger");
var VFTools = (function () {
    function VFTools() {
    }
    VFTools.gammaToLinearSpace = function (f) {
        return this.HdrToGamma ? Math.pow(f, 2.2) : f;
    };
    VFTools.linearToGammaSpace = function (f) {
        return this.HdrToGamma ? Math.pow(f, 1 / 2.2) : f;
    };
    VFTools.isEmptyColor0 = function (color) {
        return !(color["r"] > 0 || color["g"] > 0 || color["b"] > 0 || color["a"] > 0);
    };
    VFTools.GammaColor = function (color) {
        return new babylonjs_1.Color3(VFTools.gammaToLinearSpace(color["r"]), VFTools.gammaToLinearSpace(color["g"]), VFTools.gammaToLinearSpace(color["b"]));
    };
    VFTools.Color = function (color) {
        return new babylonjs_1.Color3(color["r"], color["g"], color["b"]);
    };
    VFTools.comparePathWithInaccuracy = function (path1, path2, inaccuracy) {
        if (inaccuracy === void 0) { inaccuracy = 2; }
        if (path1 === path2) {
            return true;
        }
        if (inaccuracy === 0) {
            return false;
        }
        if (path1.endsWith(path2)) {
            logger_1.default.debug("Compare '" + path1 + "' with '" + path2 + "' and an inaccuracy of " + inaccuracy);
            var array = path1.split("/");
            for (var i = 0; i < inaccuracy; i++) {
                array = array.slice(1);
                var newPath = "/";
                newPath += array.join("/");
                if (newPath === path2) {
                    return true;
                }
            }
        }
        return false;
    };
    VFTools.HdrToGamma = true;
    return VFTools;
}());
exports.default = VFTools;
